var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.602,
    height: 12.41,
    viewBox: "0 0 20.602 12.41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M0 6.183h19.368M13.867.53l5.675 5.675-5.675 5.675"
  })));
};
export { SvgArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMC42MDIiIGhlaWdodD0iMTIuNDEiIHZpZXdCb3g9IjAgMCAyMC42MDIgMTIuNDEiPgogIDxnIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNSI+CiAgICA8cGF0aCBkPSJNMCA2LjE4M2gxOS4zNjhNMTMuODY3LjUzbDUuNjc1IDUuNjc1LTUuNjc1IDUuNjc1Ii8+CiAgPC9nPgo8L3N2Zz4K";